import _ from 'lodash'
import moment from 'moment-timezone'
import { connect } from 'react-redux'
import styled from 'styled-components'
import * as styles from '../assets/styles/eventOverview'
import Inventory from './Inventory'
import type { Map } from 'immutable'

const getNotAvailableMessage = (date: string) => {
  let msg = 'Booking for this event has not been opened yet, please check back at a later date.'
  if (date) {
    if (date.indexOf('T') !== -1) {
      const openDate = moment(date).format('MMMM D, YYYY')
      msg = `Booking for this event opens on ${openDate}.`
    }
  }
  return msg
}

interface InventoryAreaProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inventoryData: { [key: string]: any }[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inventoryEdits: { [inventoryId: string]: any }
  isPrivate: boolean
  isBookable: boolean
  isEventOpened: boolean
  date: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tieredEvents: any[] | null
  isExperienceMode: boolean
}

const InventoryList = ({
  inventoryData,
  inventoryEdits,
  isPrivate,
  isBookable,
  isEventOpened,
  date,
  tieredEvents,
  isExperienceMode,
}: InventoryAreaProps) => {
  const isNotAvailable = !isEventOpened && _.isEmpty(inventoryData)

  if (isNotAvailable) {
    const notAvailableMessage = getNotAvailableMessage(date)
    return <AlertMessage message={notAvailableMessage} />
  }

  const isSoldOut = _.isEmpty(inventoryData) || (!isExperienceMode && isPrivate && !isBookable)

  if (isSoldOut) {
    return <AlertMessage message="This event is sold out." />
  }

  const sortedInventory = _.sortBy(inventoryData, 'viewOrder')
    .filter(inventoryItem => !_.isArray(tieredEvents) || tieredEvents.indexOf(inventoryItem.inventoryId) === -1)
    .filter(inventoryItem => {
      const { inventoryId, inventoryType } = inventoryItem
      const inventoryEdit = inventoryEdits && inventoryEdits[inventoryId]
      const remainingQuantity = Math.min(
        inventoryItem.maxQuantity,
        inventoryEdit ? inventoryEdit.remainingQuantity : inventoryItem.maxQuantity
      )

      return remainingQuantity > 0 || inventoryType === 'REQUEST'
    })

  return (
    <div>
      {sortedInventory.map(inventoryItem => (
        <div key={inventoryItem.id}>
          <Inventory inventoryItem={inventoryItem} inventoryEdits={inventoryEdits} />
          <StyledHr />
        </div>
      ))}
    </div>
  )
}

interface State {
  userSelection: Map<string, string>
  queryObj: {
    eventId: string
    experienceId: string
  }
}

const mapStateToProps = (state: State) => {
  const {
    userSelection,
    queryObj: { eventId, experienceId },
  } = state

  return {
    isBookable: userSelection.get('eventId') === eventId,
    isExperienceMode: !!experienceId,
  }
}

export default connect(mapStateToProps)(InventoryList)

const AlertMessage = ({ message }: { message: string }) => <StyledAlertMessageContainer>{message}</StyledAlertMessageContainer>

const { fonts_color_secondary: fontsColorSecondary } = window.widgetInit.settings
const StyledAlertMessageContainer = styled.div`
  background-color: ${styles.rgbaCellBackground};
  padding: 20px;
  font-size: 18px;
  font-style: italic;
  color: ${fontsColorSecondary};
`

const StyledHr = styled.hr`
  border: 1px solid ${styles.rgbaLineBackground};
  margin: 0;
`
